import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Icon, { GLYPHS } from '../../../../common/icon';
import { card } from '../shapes';
import { t } from '../../../../../modules/infra/i18n';

const PaymentList = ({
  cards,
  canDelete,
  onCardDelete,
  canChangeDefault,
  onSetDefault,
  canSelect,
  onCardSelect,
  isSelected,
  isDefaultSelected,
}) => (
  <div className="o-tableize o-tableize--middle">
    <div className="o-tableize__row c-label">
      <div className="o-tableize__cell u-pr" display-if={canChangeDefault}>
        {t('common:payment_card.default_header')}
      </div>
      <div className="o-tableize__cell u-pr" display-if={canSelect}>
        {t('common:payment_card.select_header')}
      </div>
      <div className="o-tableize__cell u-pr">{t('common:payment_card.card_info_header')}</div>
      <div
        display-if={canDelete}
        className="o-tableize__cell u-pr"
      >
        {t('common:buttons.delete')}
      </div>
    </div>
    {cards.map(item => (
      <div className="o-tableize__row epsilon" key={item.id} data-automation-id={`payment-card-${item.id}`}>
        <div className="o-tableize__cell u-text-center" display-if={canChangeDefault}>
          <label className="c-radio u-mr" onClick={onSetDefault(item)}>
            <input
              className="c-radio__input"
              type="radio"
              checked={isDefaultSelected(item)}
            />
            <span className="c-radio__trigger c-radio__trigger_size-s" />
          </label>
        </div>
        <div className="o-tableize__cell u-text-center" display-if={canSelect}>
          <label className="c-radio u-mr" onClick={() => onCardSelect(item)}>
            <input
              className="c-radio__input"
              type="radio"
              checked={isSelected(item)}
            />
            <span className="c-radio__trigger c-radio__trigger_size-s" />
          </label>
        </div>
        <div
          className={classnames(
            'o-tableize__cell o-tableize__cell--fill dark-mode-white',
            { 'u-type--semibold': isSelected(item) || isDefaultSelected(item) }
          )}
        >
          {item.brand} {item.last4}
        </div>
        <div
          display-if={canDelete}
          className="o-tableize__cell u-text-center"
        >
          <button
            type="button"
            className="c-btn c-btn--blank u-p0 u-co-red"
            onClick={onCardDelete(item.id)}
          >
            <Icon glyph={GLYPHS.trash} />
          </button>
        </div>
      </div>
    ))}
  </div>
);

PaymentList.propTypes = {
  cards: PropTypes.arrayOf(card).isRequired,
  canDelete: PropTypes.bool.isRequired,
  onCardDelete: PropTypes.func.isRequired,
  canChangeDefault: PropTypes.bool.isRequired,
  onSetDefault: PropTypes.func.isRequired,
  canSelect: PropTypes.bool.isRequired,
  onCardSelect: PropTypes.func.isRequired,
  isSelected: PropTypes.func.isRequired,
  isDefaultSelected: PropTypes.func.isRequired,
};

PaymentList.defaultProps = {
  onCardSelect: () => null,
};

export default PaymentList;
